/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { useLocalization } from '@/data/Localization';
import { normalizeStoreTokenPath } from '@/data/utils/normalizeStoreTokenPath';

type TranslatedRoutes = ReturnType<typeof useLocalization<'Routes'>>;

const VALID_ORIGINS = [
	'https://www.dpstreet.mx',
	'https://v9prodauth.dpstreet.mx',
	'https://dpstreetv2.v9qa.solemti.net',
	'https://v9qa.dpstreet.mx',
	'https://localhost:3343',
];

export const buildCanonicalUrl = ({
	path,
	urlKeywordName,
	staticRoutes,
	origin,
	pageGroup,
}: {
	path: string[] | string | undefined;
	locale: string;
	urlKeywordName?: string;
	staticRoutes: TranslatedRoutes;
	origin?: string;
	pageGroup?: string;
}) => {
	const normalizedPath = [normalizeStoreTokenPath({ path, storeUrlKeyword: urlKeywordName })]
		.flat()
		.filter(Boolean)
		.join('/');
	const found = Object.entries(staticRoutes).some(
		([_, value]) =>
			typeof value === 'object' && normalizedPath && value.route.t() === normalizedPath
	);
	if (found) {
		// static route doesn't need
		return '';
	} else {
		const url = `${normalizedPath ? '/' + normalizedPath : '/'}`;
		const originUrl = origin && VALID_ORIGINS.includes(origin) ? origin : '';

		return `${url !== '/' ? `${originUrl}${url}` : originUrl}${
			pageGroup === 'ProductPage' ? '' : '/'
		}`;
	}
};
